<template>
	<div class="pui-form">
		<mtiporesolucion-modals :modelName="modelName"></mtiporesolucion-modals>
		<!--<pui-form-header
			v-if="modelLoaded"
			:showHeader="!isCreatingElement">
			<mtiporesolucion-form-header
				:modelPk="modelPk"
			></mtiporesolucion-form-header>
		</pui-form-header>-->
		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<v-layout wrap class="pui-form-layout">
				<v-flex xs12 md12>
					<pui-field-set :title="getTitleDatos">
						<v-layout wrap>
							<!-- IDTIPRES -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`idtipres-mtiporesolucion`"
									v-model="model.idtipres"
									:label="$t('mtiporesolucion.idtipres')"
									disabled
									toplabel
									maxlength="10"
								></pui-text-field>
							</v-flex>
							<!-- CODRESEDI -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`codresedi-mtiporesolucion`"
									v-model="model.codresedi"
									:label="$t('mtiporesolucion.codresedi')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="3"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- NAME -->
							<v-flex xs12 md4>
								<pui-text-field
									:id="`name-mtiporesolucion`"
									v-model="model.name"
									:label="$t('mtiporesolucion.name')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="30"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- FECBAJA -->
							<v-flex xs12 md3>
								<pui-date-field
									:id="`fecbaja-mtiporesolucion`"
									v-model="model.fecbaja"
									:label="$t('mtiporesolucion.fecbaja')"
									:disabled="formDisabled"
									toplabel
									time
								></pui-date-field>
							</v-flex>
						</v-layout>
						<!-- MINI AUDIT -->
						<pui-form-mini-audit class="pl-2" :model="model" v-if="!isCreatingElement"></pui-form-mini-audit>
					</pui-field-set>
				</v-flex>
			</v-layout>

			<!-- Page Footer -->
			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndNew="saveAndNew"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import {PuiFormMethodsMixin} from '@Pui9Components';
import mtiporesolucionActions from './MtiporesolucionActions';
import mtiporesolucionModals from './MtiporesolucionModals.vue';

export default {
	name: 'mtiporesolucion-form',
	mixins: [PuiFormMethodsMixin],
	components: {
		'mtiporesolucion-modals': mtiporesolucionModals
	},
	data() {
		return {
			modelName: 'mtiporesolucion',
			actions: mtiporesolucionActions.formActions
		};
	},
	methods: {
		afterGetData() {
			// Do something after get data from server
		}
	},
	computed: {
		getTitleDatos() {
			return this.$t('form.mtiporesolucion');
		}
	},
	created() {}
};
</script>
